import { render, staticRenderFns } from "./Carousel3dEffect.vue?vue&type=template&id=899f8e64&scoped=true"
import script from "./Carousel3dEffect.vue?vue&type=script&lang=js"
export * from "./Carousel3dEffect.vue?vue&type=script&lang=js"
import style0 from "./Carousel3dEffect.vue?vue&type=style&index=0&id=899f8e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899f8e64",
  null
  
)

export default component.exports